import { AccountBalance } from '@material-ui/icons';
import React from 'react';
import Card from '../../components/Card/Card';
import CardHeader from '../../components/Card/CardHeader';
import CardBody from '../../components/Card/CardBody';
import Lang from '../../variables/i18n';
import CardFooter from '../../components/Card/CardFooter';
import { Navigate } from 'react-router';
import TransactionDetails from '../../components/TransactionDetails';
import TransactionsTable from '../../components/TransactionsTable';
import CardTitle from '../../components/CardTitle';
import CustomTabs from '../../components/CustomTabs/CustomTabs';
import ManualAmountsTable from '../../components/ManualAmountsTable';
import VaultWidget from '../../components/VaultWidget';
import GridItem from '../../components/Grid/GridItem';
import GridContainer from '../../components/Grid/GridContainer';

const VaultView = () => {
	return (
		<Card>
			<CardHeader>
				<CardTitle title={VaultRoute.name} icon={<AccountBalance />} />
			</CardHeader>
			<CardBody>
				<GridContainer>
					<GridItem xs={4}>
						<VaultWidget shift={1} />
					</GridItem>
					<GridItem xs={4}>
						<VaultWidget shift={2} />
					</GridItem>
					<GridItem xs={4}>
						<VaultWidget month />
					</GridItem>
				</GridContainer>
				<CustomTabs
					headerColor={'info'}
					tabs={[
						{
							tabName: 'Συναλλαγές',
							tabContent: <TransactionsTable showCreate />,
						},
						{
							tabName: 'Κλείσιμο ταμείου',
							tabContent: <ManualAmountsTable />,
						},
					]}
				/>
			</CardBody>
			<CardFooter>
				<span />
			</CardFooter>
		</Card>
	);
};

const VaultRoute = {
	path: 'cash',
	name: Lang.vaultView.title,
	icon: AccountBalance,
	children: [
		{ path: '/', element: <VaultView /> },
		{ path: '/create', element: <TransactionDetails create /> },
		{ path: 'view', element: <Navigate to="../" /> },
		{ path: 'view/:transactionId', element: <TransactionDetails /> },
	],
};

export default VaultRoute;
